module.exports = __webpack_public_path__ + "static/media/mon_sat_everyday_digital_footy2024.08843d4c.png";